import { Component, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Notification } from '../notification/notification';

@Component({
  selector: 'ui-notification-error',
  imports: [NgIcon, Notification],
  templateUrl: './notification-error.html',
})
export class NotificationError {
  uuid = input.required<string>();
  duration = input.required<number>();
  title = input.required<string>();
  subtitle = input<string>('');
}
